import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { hooks } from '../../../../config/api';
var PAGINATION = {
  number: 1,
  size: 100
};
export var useFindConditions = function useFindConditions(contactId) {
  var _response$data$data, _response$data;
  var filters = {};
  var options = {
    page: PAGINATION,
    queryConfig: {
      placeholderData: undefined
    }
  };
  var _ref = hooks.useFind("people/".concat(contactId, "/initiative_conditions"), filters, options) || {},
    response = _ref.data,
    isLoading = _ref.isLoading;
  var results = (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [];
  var populations = _filterInstanceProperty(results).call(results, function (result) {
    return result.is_enhanced;
  });
  var conditions = _filterInstanceProperty(results).call(results, function (result) {
    return !result.is_enhanced;
  });
  return {
    conditions: conditions,
    populations: populations,
    isLoading: isLoading
  };
};
//# sourceMappingURL=useFindConditions.js.map